// extracted by mini-css-extract-plugin
export default {"wrapper":"vimeo__wrapper__gVL6q","full":"vimeo__full__G945f","maintainAspectRatio":"vimeo__maintainAspectRatio__esc9w"};